import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SucursalPersonaDTO } from "app/main/apps/shared/interfaces/sucursal-persona.interface";
import {
    Role,
    RolEncargadoDTO,
    RolRepresentanteDTO,
} from "app/main/apps/shared/interfaces/usuario.interface";
import { OrdenesCompraService } from "app/main/apps/shared/services/rest/orden-compra.service";
import { SucursalesService } from "app/main/apps/shared/services/rest/sucursales.service";
import { UsuarioService } from "app/main/apps/shared/services/rest/usuario.service";
import { config as CONFIG } from "app/app.config";
import { Moment } from "moment";
import { ClienteService } from "app/main/apps/shared/services/rest/cliente.service";
import { Sucursal } from "app/main/apps/shared/interfaces/sucursal.interface";
import { ClienteDTO } from "app/main/apps/shared/interfaces/cliente.interface";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { finalize } from "rxjs/operators";

@Component({
    selector: "app-dialog-reporte-excel",
    templateUrl: "./dialog-reporte-excel.component.html",
    styleUrls: ["./dialog-reporte-excel.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogReporteExcelComponent implements OnInit {
    formFactura: FormGroup;
    listaClientes: ClienteDTO[];
    listaSucursales:Sucursal[];
    config;
    esSupervisor:boolean=false;
    procesando:boolean=false;
    constructor(
        public dialogRef: MatDialogRef<DialogReporteExcelComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        private _sucursalesSrvc: SucursalesService,
        private _ordenesCompraSrvc: OrdenesCompraService,
        private _usuarioSrvc: UsuarioService,
        private _clienteSrvc: ClienteService,
        private _menuUsuarioSrvc: MenuUsuarioService,
    ) {
        this.config = CONFIG;
    }

    ngOnInit(): void {
        this.esSupervisor=this._menuUsuarioSrvc.esSupervisor();
        if (!this.esSupervisor){
            let idCliente: number;
            let roles: (
                | Role
                | RolEncargadoDTO
                | RolRepresentanteDTO
            )[] = this._usuarioSrvc.getPerfil().roles;
            roles.forEach((r) => {
                if (r.id == this.config.roles.representante.rol) {
                    let rol: RolRepresentanteDTO = r as RolRepresentanteDTO;
                    idCliente = rol.cliente.id;
                }

                if (r.id == this.config.roles.encargado.rol) {
                    let rol: RolEncargadoDTO = r as RolEncargadoDTO;
                    idCliente = rol.sucursal.cliente.id;
                }
            });

            this._clienteSrvc.fetchSucursales(idCliente)
                .subscribe(resp=>{
                    this.listaSucursales = resp;
            })
        }
        else{    
            this._clienteSrvc.fetchClientes()
                .subscribe(resp=>{
                    this.listaClientes=resp.content;
            })
        }
        this.initFormFactura();
    }

    initFormFactura() {
        this.formFactura = this.fb.group({
            rango: this.fb.group({
                inicio: [null, { validators: [Validators.required] }],
                termino: [null, { validators: [Validators.required] }],
            }),

            sucursales: [{value:null,disabled:this.esSupervisor?true:false}, { validators: [Validators.required] }],
            clientes: [{value:null,disabled:!this.esSupervisor?true:false}, { validators: [Validators.required] }],
        });
    }

    get rango() {
        return this.formFactura.get("rango");
    }

    get inicio() {
        return this.formFactura.get("rango").get("inicio");
    }

    get termino() {
        return this.formFactura.get("rango").get("termino");
    }

    get sucursales() {
        return this.formFactura.get("sucursales");
    }

    get clientes() {
        return this.formFactura.get("clientes");
    }

    guardar() {
        
        let filtro:number[]=[];
        if (this.esSupervisor){
            let s: ClienteDTO[] = this.formFactura.get("clientes").value;
            filtro = s.map((cliente) => cliente.id);
        }
        else{
            let s: SucursalPersonaDTO[] = this.formFactura.get("sucursales").value;
            filtro = s.map((sucursal) => sucursal.id);
        }    

        this.procesando=true;
        this._ordenesCompraSrvc
            .fetchReport(
                this.inicio.value.format("YYYY-MM-DD"),
                this.termino.value.format("YYYY-MM-DD"),
                filtro,this.esSupervisor
            )
            .pipe(finalize(()=>{this.procesando=false;}))
            .subscribe((blob) => {
                const a = document.createElement("a");
                let url = window.URL.createObjectURL(blob);
                a.download = `reporte-${this.inicio.value.format(
                    "YYYY-MM-DD"
                )}_al_${this.termino.value.format("YYYY-MM-DD")}.xlsx`;
                a.href = url;
                a.click();
                a.remove();

                this.dialogRef.close();
            }
            );
    }
}
